import React, { Component } from 'react'
import styled from 'styled-components'

const Box = styled.div`
  display: flex;
  margin-bottom: ${props => props.withBottomMargin ? '0' : '-1.25rem'};
  flex-wrap: wrap;
`

export default class Prompts extends Component {
  render() {
    return <Box {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/Prompts/Prompts.js